import { Reducer } from 'redux';
import { PlantasState, PlantasTypes } from './types';

const INITIAL_STATE: PlantasState = {
  seatmapsList: [],
  seatmapData: null,
  totalCount: 0,
  loading: false,
  error: false,
};

const reducer: Reducer<PlantasState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PlantasTypes.LIST_SEATMAPS_REQUEST:
      return { ...state, loading: true, error: false, seatmapsList: [] };
    case PlantasTypes.LIST_SEATMAPS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        seatmapsList: action.payload.seatmapsList,
        totalCount: action.payload.totalCount,
      };
    case PlantasTypes.LIST_SEATMAPS_FAILURE:
      return { ...state, loading: false, error: true, seatmapsList: [] };

    case PlantasTypes.GET_SEATMAP_REQUEST:
      return { ...state, loading: true, error: false, seatmapData: null };
    case PlantasTypes.GET_SEATMAP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        seatmapData: action.payload.seatmapData,
      };
    case PlantasTypes.GET_SEATMAP_FAILURE:
      return { ...state, loading: false, error: true, seatmapData: null };

    case PlantasTypes.CREATE_SEATMAP_REQUEST:
      return { ...state, loading: true, error: false };
    case PlantasTypes.CREATE_SEATMAP_SUCCESS:
      return { ...state, loading: false, error: false };
    case PlantasTypes.CREATE_SEATMAP_FAILURE:
      return { ...state, loading: false, error: true };

    case PlantasTypes.UPDATE_SEATMAP_REQUEST:
      return { ...state, loading: true, error: false };
    case PlantasTypes.UPDATE_SEATMAP_SUCCESS:
      return { ...state, loading: false, error: false };
    case PlantasTypes.UPDATE_SEATMAP_FAILURE:
      return { ...state, loading: false, error: true };

    case PlantasTypes.CLEAR_SEATMAP_DATA:
      return { ...state, seatmapData: null };

    case PlantasTypes.DELETE_SEATMAP_REQUEST:
      return { ...state, loading: true, error: false };
    case PlantasTypes.DELETE_SEATMAP_SUCCESS:
      return { ...state, loading: false, error: false };
    case PlantasTypes.DELETE_SEATMAP_FAILURE:
      return { ...state, loading: false, error: true };

    default:
      return state;
  }
};

export default reducer;
